import { useDocuments } from '@/lib/documents';
import type { Program } from '@/lib/types';
import { DocumentList } from '@/components/documents/DocumentList';

/** Files on a task; drop a file onto the list to file it here. */
export function TaskAttachments({
  program,
  taskId,
  taskTitle,
  canUpload,
}: {
  program: Program;
  taskId: string;
  taskTitle: string;
  canUpload: boolean;
}) {
  const docs = useDocuments(program.id, { taskId });
  return (
    <DocumentList
      program={program}
      docs={docs.data}
      loading={docs.isLoading}
      uploadTarget={{ taskId, label: taskTitle }}
      canUpload={canUpload}
      emptyText="No attachments."
    />
  );
}
